import { Layout, ScreenRows } from 'components/_shared/widgets/gallery';
import { ShopLayoutConfigInterface } from './types';

const GALLERY_SIZE_ESSENTIALS = 7;
const MAX_GALLERIES_PER_SHOP_ESSENTIALS = 1;

const DESKTOP_TABLET_LAYOUT_1_ESSENTIALS: ScreenRows = [4, 3];
const DESKTOP_TABLET_LAYOUT_2_ESSENTIALS: ScreenRows = [3, 4];
const MOBILE_LAYOUT_1_ESSENTIALS: ScreenRows = [2, 2, 1, 2];

const LAYOUT_COLLECTION_ESSENTIALS: Layout[] = [
  [
    MOBILE_LAYOUT_1_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_1_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_1_ESSENTIALS,
  ],
  [
    MOBILE_LAYOUT_1_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_2_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_2_ESSENTIALS,
  ],
  [
    [2, 1, 2, 2],
    [2, 3, 2],
    [2, 3, 2],
  ],
  [
    [1, 2, 2, 2],
    DESKTOP_TABLET_LAYOUT_1_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_1_ESSENTIALS,
  ],
  [
    [1, 1, 2, 2, 1],
    DESKTOP_TABLET_LAYOUT_2_ESSENTIALS,
    DESKTOP_TABLET_LAYOUT_2_ESSENTIALS,
  ],
];

// NOTE: withHero and accentFirstRow are treated as mutually exclusive, with withHero being prioritised
export const shopLayoutConfig: Record<string, ShopLayoutConfigInterface> = {
  'everyday-essentials': {
    layout: LAYOUT_COLLECTION_ESSENTIALS,
    withHero: true,
    gallerySize: GALLERY_SIZE_ESSENTIALS,
    maxGalleriesPerShop: MAX_GALLERIES_PER_SHOP_ESSENTIALS,
  },
  'extra-time-deals': {
    layout: [[2, 3, 4]],
    withHero: false,
    gallerySize: 12,
    maxGalleriesPerShop: 1,
    accentFirstRow: true,
  },
  default: {
    layout: [[2, 3, 4]],
    withHero: false,
    gallerySize: 12,
    maxGalleriesPerShop: 1,
  },
};
